import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import { Mobile, NotMobile } from "../../../hocs/Responsive";
import { TimeRange } from "../../../components/time/timeRange/TimeRange";
import { ProfileSelector } from "../../../components/charts/profileSelector/ProfileSelector";
import { HomePageBarChart } from "./HomePageBarChart";
import { ChartTitle } from "../Dashboard";
import {
  LocalLoader,
  LocalLoaderWrapper,
} from "../../../components/loader/localLoader/LocalLoader";
import { isMultipleUserLevel } from "../../../store/account";
import { getReportsPeriod } from "../../../store/reports/reports.selectors";
import { isBarchartLoading } from "../../../store/reports/reducers/barchart/barchart.selectors";
import { changeProfile } from "../../../store/reports/reports.actions";

import "./BarChartSection.scss";

const TimePeriodInfoMobile = () => {
  const period = useSelector(getReportsPeriod);

  return (
    <div className={"time-period__container"}>
      <TimeRange className={"time-period__info"} period={period} />
    </div>
  );
};

export const BarChartSection = () => {
  const dispatch = useDispatch();

  const isMultiple = useSelector(isMultipleUserLevel);
  const isLoading = useSelector(isBarchartLoading);

  const handleProfileChange = useCallback(
    (profile) => {
      dispatch(changeProfile(profile));
    },
    [dispatch]
  );

  return (
    <section className="home-page__barchart barchart">
      <ChartTitle title={<FormattedMessage id="activity_and_blocks" />} />
      {isMultiple && <ProfileSelector onProfileChange={handleProfileChange} />}
      <Mobile>
        <div className={"homepage-reports__hint"}>
          *<FormattedMessage id={"report_chart_legend"} />
        </div>
        <TimePeriodInfoMobile />
      </Mobile>
      <LocalLoaderWrapper>
        <div className={"chart-wrapper"}>
          {isLoading && <LocalLoader />}
          <HomePageBarChart />
          <div aria-hidden={true} className={"legend"}>
            <div className={"legend__item legend__item--activity"}>
              <FormattedMessage id={"internet_activity"} />
            </div>
            <div className={"legend__item legend__item--blocked"}>
              <FormattedMessage id={"blocked_activity"} />
            </div>
            <div className={"legend__item legend__item--malware"}>
              <FormattedMessage id={"malware_and_phishing_blocked"} />
            </div>
          </div>
        </div>
      </LocalLoaderWrapper>
      <NotMobile>
        <div aria-hidden={true} className={"homepage-reports__hint"}>
          *<FormattedMessage id={"report_chart_legend"} />
        </div>
      </NotMobile>
    </section>
  );
};
